import { AuthData, SignInErrorType } from "./reducer";
import sendAuthRequest, { decodeJwt } from "../../configuration/api/authApiHelper";
import { clearAuthData, saveAuthData } from "../../helpers/localStorageHelpers";
import { api, useApi } from "../../configuration/api/apiHelper";
import { CommunicationChannel, EventType, RegisterUserCommand, UpdateUserDetailsCommand, UserDetailsViewModel } from "../../configuration/api/apiSchema";
// import { getAccountDetails } from "../Account/ProfileDetails/actions";

// Sign In User (get access token)
export enum SIGN_IN_USER {
    REQUEST = "SIGN_IN_USER_REQUEST",
    SUCCESS = "SIGN_IN_USER_SUCCESS",
    ERROR = "SIGN_IN_USER_ERROR",
}

export const signInUserRequest = () => {
    return {
        type: SIGN_IN_USER.REQUEST
    };
};

export const signInUserError = (errorType: SignInErrorType) => {
    return {
        type: SIGN_IN_USER.ERROR,
        errorType: errorType
    };
};

type AuthTokenWithMetadata = {
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    refresh_token: string;
}

export const signInUser = (username: string, password: string) => {
    let payload = {
        "grant_type": "password",
        "client_id": "ro.client",
        "username": username,
        "password": password,
        "scope": "openid profile handyman_web_api offline_access",
    };

    return (dispatch: any) => {
        dispatch(signInUserRequest());
        sendAuthRequest("/connect/token", "POST", payload, "form-data")
            .then((response: any) => {

                //TODO: Remove, testing purpose
                setTimeout(() => dispatch(getTokenSuccess(response, SIGN_IN_USER.SUCCESS)),
                    2000
                );
            })
            .catch((error: any) => {
                clearAuthData()
                dispatch(logoutAction());
                console.error("auth login request error", error);
                const typedError = error as AuthErrorObject;

                if (typedError.error_description === "Incorrect credentials" &&
                    typedError.error === "invalid_request"
                ) {
                    dispatch(signInUserError(SignInErrorType.incorrectCredentials));
                }
            });
    };
};

// Refresh token
export enum REFRESH_TOKEN {
    REQUEST = "REFRESH_TOKEN_REQUEST",
    SUCCESS = "REFRESH_TOKEN_SUCCESS",
}

export const refreshTokenRequest = () => {
    return {
        type: REFRESH_TOKEN.REQUEST
    };
};

interface AuthErrorObject {
    error: string;
    error_description: string;
}

export const refreshToken = (refreshToken: string) => {
    let payload = {
        "grant_type": "refresh_token",
        "client_id": "ro.client",
        "refresh_token": refreshToken
    };

    return (dispatch: any) => {
        dispatch(signInUserRequest());
        sendAuthRequest("/connect/token", "POST", payload, "form-data")
            .then((response: any) => {

                //TODO: Remove, testing purpose
                setTimeout(() => dispatch(getTokenSuccess(response, SIGN_IN_USER.SUCCESS)),
                    2000
                );
            })
            .catch((error: any) => {
                clearAuthData()
                dispatch(logoutAction());
                console.error("auth login request error", error);
                const typedError = error as AuthErrorObject;

                if (!typedError.error) {
                    dispatch(signInUserError(SignInErrorType.unknown));
                }

                if (typedError.error_description === "Incorrect credentials" &&
                    typedError.error === "invalid_request"
                ) {
                    dispatch(signInUserError(SignInErrorType.incorrectCredentials));
                }
            });
    };
};

const getTokenSuccess = (authTokenWithMetadata: AuthTokenWithMetadata, type: REFRESH_TOKEN.SUCCESS | SIGN_IN_USER.SUCCESS) => {
    const decodedJwtToken = decodeJwt(authTokenWithMetadata.access_token);

    const authData = {
        access_token: authTokenWithMetadata.access_token,
        expires_in: authTokenWithMetadata.expires_in,
        fullName: decodedJwtToken.name,
        role: decodedJwtToken.role,
        status: decodedJwtToken.status,
        refresh_token: authTokenWithMetadata.refresh_token
    } as AuthData;

    saveAuthData(authData)

    return {
        type: type,
        authData: authData
    };
};

// Logout
export const LOGOUT = "LOGOUT";

export const logoutAction = () => {

    clearAuthData()
    document.location.href="/sign-in";

    return {
        type: LOGOUT
    };
};

export const logout = () => {
    return (dispatch: any) => {
        dispatch(logoutAction());
    };
};

// Sign Up



// Sign Up User Otp request
export enum SEND_SIGN_UP_USER_OTP {
    REQUEST = "SEND_SIGN_UP_USER_OTP_REQUEST",
    SUCCESS = "SEND_SIGN_UP_USER_OTP_SUCCESS",
}

export const sendSignUpUserOtpRequestAction = () => {
    return {
        type: SEND_SIGN_UP_USER_OTP.REQUEST
    };
};

export const sendSignUpUserOtpSuccessAction = () => {
    return {
        type: SEND_SIGN_UP_USER_OTP.SUCCESS
    };
};

export const sendSignUpUserOtp = (otpContactReference: string, otpCommunicationChannel: CommunicationChannel) => {
    return async (dispatch: any) => {
        dispatch(sendSignUpUserOtpRequestAction());

        // TODO: Make proper name via swagger
        const response = await useApi(() => api.users.postUsers(
            {
                contactReference: otpContactReference,
                eventType: EventType.Register,
                otpCommunicationChannel: otpCommunicationChannel
            }
        ));

        if (response.result) {
            dispatch(sendSignUpUserOtpSuccessAction());
        }
        else {
            // todo: Error show
            // dispatch(throwError("" + response));
        }
    };
};

// Sign Up User
export enum SIGN_UP_USER {
    REQUEST = "SIGN_UP_USER_REQUEST",
    SUCCESS = "SIGN_UP_USER_SUCCESS",
    ERROR = "SIGN_UP_USER_ERROR",
}

export const sendSignUpUserRequestAction = () => {
    return {
        type: SIGN_UP_USER.REQUEST
    };
};

export const sendSignUpUserSuccessAction = () => {
    return {
        type: SIGN_UP_USER.SUCCESS
    };
};

// TODO: Make errorType with types 
export const sendSignUpUserError = (errorType: any) => {
    return {
        type: SIGN_UP_USER.ERROR,
        errorType: errorType
    };
};

export interface OtpErrorObject {
    type: string;
    message: string;
}

export enum OtpErrorType {
    InvalidCode = "invalid_code",
    CodeExpired = "code_expired",
}

export enum UserRoles {
    HandymanRoleId = "cc1cb582-612a-473b-9461-c66423dff374",
    CustomerRoleId = "6c875148-f700-4975-a1a9-6ad7e713758b"
}

export const sendSignUpUser = (command: RegisterUserCommand) => {
    return async (dispatch: any) => {
        dispatch(sendSignUpUserRequestAction());

        const response = await useApi(() => api.users.registerCreate(command));

        if (response.result === true) {
            dispatch(sendSignUpUserSuccessAction());
        }
        else {
            let errorObject = response.error as OtpErrorObject;

            switch (errorObject.type) {
                case OtpErrorType.CodeExpired:
                    dispatch(sendSignUpUserError(OtpErrorType.CodeExpired));
                    break;
                case OtpErrorType.InvalidCode:
                    dispatch(sendSignUpUserError(OtpErrorType.InvalidCode));
                    break;
                default:
                    // TODO: error
                    // dispatch(throwError(errorObject.message));
                    break;
            }
        }
    };
};


// Check duplicate email

export enum CHECK_DUPLICATE_EMAIL {
    REQUEST = "CHECK_DUPLICATE_EMAIL_REQUEST",
    SUCCESS = "CHECK_DUPLICATE_EMAIL_SUCCESS",
}

export const checkDuplicateEmailRequestAction = () => {
    return {
        type: CHECK_DUPLICATE_EMAIL.REQUEST
    };
};

export const checkDuplicateEmailSuccessAction = (isDuplicatedEmailError: boolean) => {
    return {
        type: CHECK_DUPLICATE_EMAIL.SUCCESS,
        isDuplicatedEmailError: isDuplicatedEmailError
    };
};


export const checkDuplicateEmail = (email: string) => {
    return async (dispatch: any) => {
        dispatch(checkDuplicateEmailRequestAction());

        const response = await useApi(() =>
            api.users.existingEmailCreate(
                {
                    email: email
                }
            ));

        if (response.error) {
            dispatch(checkDuplicateEmailSuccessAction(true));
        }
        else {
            dispatch(checkDuplicateEmailSuccessAction(false));
        }
    };
};

// Get user details
export enum GET_USER_DETAILS {
    REQUEST = "GET_USER_DETAILS_REQUEST",
    SUCCESS = "GET_USER_DETAILS_SUCCESS",
}

export const getUserDetailsRequestAction = () => {
    return {
        type: GET_USER_DETAILS.REQUEST
    };
};

export const getUserDetailsSuccessAction = (userDetails: UserDetailsViewModel) => {
    return {
        type: GET_USER_DETAILS.SUCCESS,
        userDetails: userDetails,
    };
};

export const getUserDetails = (userId?: string) => {
    return async (dispatch: any) => {
        dispatch(getUserDetailsRequestAction());

        const response = await useApi(() =>
            api.users.usersList({
                userId: userId
            }));
        
        if (response.result) {
            dispatch(getUserDetailsSuccessAction(response.result));
        }
        else {
            // TODO: error
            // dispatch(throwError(response.toString()));
        }
    };
};

// Update user details

export enum UPDATE_USER_DETAILS {
    REQUEST = "UPDATE_USER_DETAILS_REQUEST",
    SUCCESS = "UPDATE_USER_DETAILS_SUCCESS",
}

export const updateUserDetailsRequestAction = () => {
    return {
        type: UPDATE_USER_DETAILS.REQUEST
    };
};

export const updateUserDetailsSuccessAction = () => {
    return {
        type: UPDATE_USER_DETAILS.SUCCESS
    };
};

export const updateUserDetails = (command: UpdateUserDetailsCommand) => {
    return async (dispatch: any) => {
        dispatch(updateUserDetailsRequestAction());

        const response = await useApi(() =>
            api.users.contactInfoUpdate(command));

        if (response.result) {
            dispatch(updateUserDetailsSuccessAction());
        }
        else {
            // TODO: error
            // dispatch(throwError(response.toString()));
        }
    };
};

// Get user details

export enum GET_CURRENT_USER_DETAILS {
    REQUEST = "GET_CURRENT_USER_DETAILS_REQUEST",
    SUCCESS = "GET_CURRENT_USER_DETAILS_SUCCESS",
}

export const getCurrentUserDetailsRequestAction = () => {
    return {
        type: GET_CURRENT_USER_DETAILS.REQUEST
    };
};

export const getCurrentUserDetailsSuccessAction = (currentUserDetails: UserDetailsViewModel) => {
    return {
        type: GET_CURRENT_USER_DETAILS.SUCCESS,
        currentUserDetails: currentUserDetails
    };
};

export const getCurrentUserDetails = (userId?: string) => {
    return async (dispatch: any) => {
        dispatch(getCurrentUserDetailsRequestAction());

        const response = await useApi(() =>
            api.users.usersList({
                userId: userId
            }));
        
        if (response.result) {
            dispatch(getCurrentUserDetailsSuccessAction(response.result));
        }
        else {
            // TODO: error
            // dispatch(throwError(response.toString()));
        }
    };
};

// Update user avatar

export enum UPDATE_USER_AVATAR {
    REQUEST = "UPDATE_USER_AVATAR_REQUEST",
    SUCCESS = "UPDATE_USER_AVATAR_SUCCESS",
}

export const updateUserAvatarRequestAction = () => {
    return {
        type: UPDATE_USER_AVATAR.REQUEST
    };
};

export const updateUserAvatarSuccessAction = () => {
    return {
        type: UPDATE_USER_AVATAR.SUCCESS
    };
};

export const updateUserAvatar = (avatarBase64: string) => {
    return async (dispatch: any) => {
        dispatch(updateUserAvatarRequestAction());

        const response = await useApi(() =>
            api.users.avatarUpdate({
                avatarBase64: avatarBase64
            }));

        if (response.result) {
            dispatch(updateUserAvatarSuccessAction());
        }
        else {
            // TODO: error
            // dispatch(throwError(response.toString()));
        }
    };
};

